module.exports = __webpack_public_path__ + "static/media/North Grove.05fa5e72.jpg";